import React from 'react';
import { motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
export function PainPoints() {
  const problems = ['Querés emprender pero no sabés por dónde arrancar', 'Probaste vender otras cosas y no funcionó como esperabas', 'Ves negocios de repostería o catering y pensás "yo también podría hacer eso"', 'No tenés capital para invertir en un local ni en stock grande', 'Buscás algo diferente, que no venda todo el mundo', 'Querés aprender algo concreto que puedas aplicar esta semana', 'El mercado está saturado de tortas, alfajores y catering genérico'];
  return <section className="w-full bg-neutral-950 py-4 md:py-8" data-id="element-136">
      <div className="max-w-4xl mx-auto px-4 sm:px-6" data-id="element-137">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-138">
          <h2 className="text-3xl md:text-5xl font-bold text-amber-50 text-center mb-2 md:mb-4 leading-tight" data-id="element-139">
            ¿Sabías que hay personas en Argentina vendiendo velas comestibles a
            $8.000 la unidad… desde su cocina?
          </h2>

          <div className="text-center mb-3 md:mb-5 space-y-1 md:space-y-2" data-id="element-140">
            <p className="text-lg text-neutral-300 leading-relaxed" data-id="element-141">
              El mercado de experiencias gourmet creció un 300% después de la
              pandemia. Eventos, casamientos, brunch y mesas dulces buscan algo
              diferente. Algo que sorprenda. Algo que nadie haya visto antes.
              <br data-id="element-142" />
              <br data-id="element-143" />
              Las velas comestibles son ese producto. Y vos podés ser de los
              primeros en dominarlo en tu ciudad.
            </p>
            <p className="text-xl md:text-2xl font-bold text-amber-400" data-id="element-144">
              El problema no sos vos. Es que nadie te enseñó el producto
              correcto.
            </p>
          </div>

          <div className="mb-3 md:mb-5" data-id="element-145">
            <h3 className="text-2xl font-bold text-amber-50 mb-2 md:mb-3 text-center" data-id="element-146">
              ❌ Lo que pasa sin el Mega Pack:
            </h3>
            <div className="bg-neutral-900 border border-rose-900/40 rounded-lg overflow-hidden" data-id="element-147">
              <div className="divide-y divide-rose-900/40" data-id="element-148">
                {problems.map((problem, index) => <motion.div key={index} initial={{
                opacity: 0,
                x: -20
              }} whileInView={{
                opacity: 1,
                x: 0
              }} viewport={{
                once: true
              }} transition={{
                delay: index * 0.1,
                duration: 0.4
              }} className="flex items-start gap-3 p-3" data-id="element-149">
                    <XIcon className="w-5 h-5 text-rose-400 flex-shrink-0 mt-0.5" data-id="element-150" />
                    <p className="text-neutral-300 text-sm" data-id="element-151">{problem}</p>
                  </motion.div>)}
              </div>
            </div>
          </div>

          <motion.h3 initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="text-2xl md:text-4xl font-bold text-amber-400 text-center" data-id="element-152">
            ¿Y si arrancás vos antes que todos los demás en tu ciudad?
          </motion.h3>
        </motion.div>
      </div>
    </section>;
}